export default __webpack_public_path__ + "static/media/logo.86fa2ab4.svg";